import { render } from "./AlignmentSpecialist.vue?vue&type=template&id=e4cdc5e0&scoped=true"
import script from "./AlignmentSpecialist.vue?vue&type=script&lang=js"
export * from "./AlignmentSpecialist.vue?vue&type=script&lang=js"

import "./AlignmentSpecialist.vue?vue&type=style&index=0&id=e4cdc5e0&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4cdc5e0"]])

export default __exports__